import consumer from "./consumer";

export function subscribeToScores(sessionId, onEvent) {
    return consumer.subscriptions.create(
        { channel: "ScoresChannel", session_id: sessionId },
        {
            connected() {
                console.log(`+++Connected to scores for Session ${sessionId}`);
            },
            disconnected() {
                console.log(`---Disconnected from scores for Session ${sessionId}`);
            },
            received(data) {
                onEvent(data);
            }
        }
    );
}